import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propShape, propArrayStr, propChildren, propStr, } from '../../../../helpers/custom-prop-types';
import SlideSearchPlanFunctions from './Parts/SlideSearchPlanFunctions';
import SlideSearchPlanPrice from './Parts/SlideSearchPlanPrice';
import SlideSearchPlanRecommended from './Parts/SlideSearchPlanRecommended';
const SlideSearchPlan = (props) => {
    const { buttonComponent, className, functions, plan } = props;
    return (_jsxs("div", Object.assign({ className: clsx('slide_search_plan', className) }, { children: [plan.isRecommended && _jsx(SlideSearchPlanRecommended, {}), _jsx("h5", Object.assign({ className: 'plan_title' }, { children: plan.title })), _jsx(SlideSearchPlanPrice, { price: plan.price }), _jsx(SlideSearchPlanFunctions, { functions: functions, list: plan.functions }), buttonComponent] })));
};
SlideSearchPlan.propTypes = {
    buttonComponent: propChildren(),
    className: propStr(),
    functions: propArrayStr().isRequired,
    plan: propShape().isRequired,
};
SlideSearchPlan.defaultProps = {
    buttonComponent: undefined,
    className: '',
};
export default SlideSearchPlan;
